let APIURL;
let BASEURL;


/**
 *  # 개발&테스트&운영 모드 분리(API 접속 및 환경설정 분리)
 */
// Region Start
// App Version Info
const VERSION = require('./../../package.json').version;

// App Environment Info
const {
  NODE_ENV, NODE_REL, VUE_APP_NODE_ENV, VUE_APP_NODE_REL,
} = process.env;
window.NODE_ENV = NODE_ENV;
window.NODE_REL = NODE_REL;
window.VUE_APP_NODE_ENV = VUE_APP_NODE_ENV;
window.VUE_APP_NODE_REL = VUE_APP_NODE_REL;
window.VERSION = VERSION;
switch (VUE_APP_NODE_ENV) {
  case 'development': { // 개발
    // APIURL = 'http://192.168.10.15:4000';
    BASEURL = 'https://test.ebssw.kr:10543';
    APIURL = `${BASEURL}/blk-api`;
  } break;
  case 'test': { // 테스트
    BASEURL = 'https://test.ebssw.kr:10543';
    APIURL = `${BASEURL}/blk-api`;
  } break;
  case 'staging':{
    BASEURL ='https://stg-www.ebssw.kr:10543';
    APIURL = `${BASEURL}/blk-api`;
  } break;
  case 'production': { // 운영
    BASEURL = 'https://www.ebssw.kr';
    APIURL = `${BASEURL}/blk-api`;
  } break;
}
window.BASEURL = BASEURL;
window.APIURL = APIURL;
if (VUE_APP_NODE_ENV === 'development' || VUE_APP_NODE_ENV === 'test') {
  console.log(
    `[ESOFScratch]
          VUE_APP_NODE_ENV : ${window.VUE_APP_NODE_ENV} | VUE_APP_NODE_REL : ${window.VUE_APP_NODE_REL}
          BASEURL : ${window.BASEURL} | API_SERVER : ${window.APIURL} | ProjectVer : ${window.VERSION}`,
  );
}
// Region End

const getCookie = function () { // / Retrieve cookie function
  const match = document.cookie.match(new RegExp('JSESSIONID' + '=([^;]+)'));
  if (match) return match[1];
};

export {
  BASEURL,
  APIURL,
  getCookie,
};
